import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

// components
import { YcTyping, YcProjects, YcTrustUs, YcAboutUs, YcContactUs } from '../../components';
import logoImg from '../../assets/images/p-home/icon.svg';
import arrow from '../../assets/images/p-home/arrow.svg';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import './home.scss';

export const Home = withTranslation(['home'])(
  class HomeClass extends PureComponent {
    characters = [
      'makers',
      'innovation',
      'designers',
      'creation',
      'expert',
      'unique',
      'young',
      'modern',
      'tech',
      'so-strong',
      'pragmatic',
      'cool',
    ];

    renderHead() {
      const { t } = this.props;

      return (
        <section id="home">
          <div className="s-head">
            <div className="black-filter" />
            <div className="wave" />
          </div>
          <div className="container">
            <div className="b-center">
              <div className="background">&nbsp;</div>
            </div>
            <div className="content">
              <img className="logo" src={logoImg} alt="Logo" />

              <p className="we-are">
                {t('home.cover.we are')}&nbsp;
                  <YcTyping words={this.characters.map(w => t('home.cover.' + w))} />
              </p>
              <p className="desc" dangerouslySetInnerHTML={{ __html: t('home.main') }}></p>
              <AnchorLink offset="84px" href="#about-us">
                <img className="arrow" src={arrow} alt="Arrow" />
              </AnchorLink>
            </div>
          </div>
        </section>
      );
    }

    render() {
      return (
        <div className="p-home">
          {this.renderHead()}
          <section className="s-we-are" id="about-us">
            <YcAboutUs />
          </section>
          <section className="s-projects" id="projects">
            <YcProjects />
          </section>
          <section className="s-trust-us">
            <YcTrustUs />
          </section>
          <section className="s-contact-us">
            <YcContactUs />
          </section>
        </div>
      );
    }
  },
);
